import { Box, CircularProgress, Modal } from "@mui/material";
import React from "react";

export const AuthenticationLoading = () => 
  <div>Authenticating...</div>

